import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import Layout from './components/Layout';
import DCEN from './components/Doctorados/DCEN';
import DEAA from './components/Doctorados/DEAA';
import DEDN from './components/Doctorados/DEDN';
import MAPL from './components/Maestrias/MAPL';
import MCSN from './components/Maestrias/MCSN';
import MEDN from './components/Maestrias/MEDN';
import MENT from './components/Maestrias/MENT';
import MENU from './components/Maestrias/MENU';
import ENT from './components/Especialidades/ENT';
import ECE from './components/Especialidades/ECE';

import ICA from './components/Licenciaturas/ICA';
import IRO from './components/Licenciaturas/IRO';
import LAEL from './components/Licenciaturas/LAEL';
import LCPL from './components/Licenciaturas/LCPL';
import LEC from './components/Licenciaturas/LEC';
import LFL from './components/Licenciaturas/LFL';
import LPS from './components/Licenciaturas/LPS';
import LSE from './components/Licenciaturas/LSE';
import LSP from './components/Licenciaturas/LSP';
import AUTI from './components/Diplomados/AUTI';
import TDAH from './components/Diplomados/TDAH';
import EAD from './components/Diplomados/EAD';
import GOOG from './components/Diplomados/GOOG';
import Universum from './components/Universum';
import BlogsDI from './components/Blogs/DI';
import BlogsDIH from './components/Blogs/DIH';
import ConferenciaDI from './components/Conferencia';


import PagoDiplomados from './components/Pagos/InscripcionDiplomados';


import Chat from './components/Chat';


import Inicio from './components/Home';
import Retro from './components/Retro';
import RetroUniversum from './components/RetroUniversum';
import Informes from './components/Informes';
import Counter from './components/Counter';
import FetchData from './components/FetchData';


class App extends Component {
    constructor(props) {
        super(props)
        this.lay = React.createRef();
        this.vincular = this.vincular.bind(this);
        this.getGuid = this.getGuid.bind(this);
    }

    vincular(url, clave, forzar) {
        this.lay.current.reportarVisita(url, clave, forzar);
    }

    getGuid() {
        return this.lay.current.getGuid();
    }

    mostrarMenu(mostrar) {
        
        //return this.lay.current.mostrarMenu(mostrar);
    }


    render() {
        return (
            <Layout ref={this.lay}>
                <Switch>
                    <Route exact path='/' render={(props) => <Inicio reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/Default.aspx' render={(props) => <Inicio  reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/Contacto.aspx' render={(props) => <Inicio reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/Principal.aspx' render={(props) => <Retro  reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/postgrados/dcen.aspx' render={(props) => <DCEN reportarVisita={this.vincular} getGuid={this.getGuid} />}/>
                    <Route path='/Doctorado/Pedagogia' render={(props) => <DCEN reportarVisita={this.vincular} getGuid={this.getGuid} />}/>
                    <Route path='/Doctorado/Educacion_y_Ambientes_de_Aprendizaje_Digital' render={(props) => <DEAA reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Doctorado/Educacion_Especial' render={(props) => <DEDN reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Maestria/Administracion_Publica' render={(props) => <MAPL reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Maestria/Sociologia_Educativa' render={(props) => <MCSN reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/postgrados/mcsn.aspx' render={(props) => <MCSN reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Maestria/Educacion_Especial' render={(props) => <MEDN reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/postgrados/medn.aspx' render={(props) => <MEDN reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Maestria/Educacion_y_Nuevas_Tecnologias' render={(props) => <MENT reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Maestria/Educacion_Nutricional' render={(props) => <MENU reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Especialidad/Educacion_y_Nuevas_Tecnologias' render={(props) => <ENT reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/postgrados/ent.aspx' render={(props) => <ENT reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Especialidad/Calidad_Educativa' render={(props) => <ECE reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/proicyteg/postgrados/ece.aspx' render={(props) => <ECE reportarVisita={this.vincular} getGuid={this.getGuid} />} />

                    <Route path='/Ingenieria/Robotica' render={(props) => <IRO reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Ingenieria/Control_y_Automatizacion' render={(props) => <ICA reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Psicologia_Social' render={(props) => <LPS reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Sociologia_Educacion' render={(props) => <LSE reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Sociologia_Politica' render={(props) => <LSP reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Filologia_y_Literatura' render={(props) => <LFL reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Contaduria_Publica' render={(props) => <LCPL reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Administracion_de_Empresas' render={(props) => <LAEL reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Licenciatura/Economia' render={(props) => <LEC reportarVisita={this.vincular} getGuid={this.getGuid} />} />

                    <Route path='/Diplomados/TDAH' render={(props) => <TDAH reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Diplomados/Autismo' render={(props) => <AUTI reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Diplomados/Formacion-Profesores-Diseño-de-Cursos-en-Linea' render={(props) => <EAD reportarVisita={this.vincular} getGuid={this.getGuid} />} />

                    <Route path='/Pagos/Diplomados' render={(props) => <PagoDiplomados reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Blogs/discapacidad-cognitiva-aspectos-clave' render={(props) => <BlogsDI reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Blogs/discapacidad-cognitiva-herramientas-diagnostico' render={(props) => <BlogsDIH reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                    <Route path='/Conferencia/discapacidad-intelectual' render={(props) => <ConferenciaDI reportarVisita={this.vincular} getGuid={this.getGuid} />} />

                    <Route path='/Universum' component={() => {
                        window.location.href = 'https://exchangeovh.icyteg.edu.mx/universum';
                        return null;
                    }} />

                    <Route path='/Universum/login.aspx' component={() => {
                        window.location.href = 'https://exchangeovh.icyteg.edu.mx/universum';
                        return null;
                    }} />

                    <Route path='/*' render={(props) => <Inicio reportarVisita={this.vincular} getGuid={this.getGuid} />} />

                    {
                        //<Route path='/Universum' render={(props) => <Universum reportarVisita={this.vincular} getGuid={this.getGuid} mostrarMenu={this.mostrarMenu} />} />

                    //    <Route path='/Universum' component={() => {
                    //    window.location.href = 'https://exchangeovh.icyteg.edu.mx/universum';
                    //    return null;
                    //}} />
                    //<Route path='/Universum/login.aspx' component={() => {
                    //    window.location.href = 'https://exchangeovh.icyteg.edu.mx/universum';
                    //    return null;
                    //}} />
                    //<Route exact path='/proicyteg/*' render={(props) => <Inicio reportarVisita={this.vincular} getGuid={this.getGuid} />} />
                        //<Route path='/Diplomados/Aplicaciones_Google' render={(props) => <GOOG reportarVisita={this.vincular} getGuid={this.getGuid} />} /> 
                    }
                </Switch>





                
            </Layout >

            )
    }

}
export default App;



// WEBPACK FOOTER //
// ./src/App.js